import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'startup-loading',
  imports: [CommonModule],
  template: `
    <div id="app-introduction" class="tw-flex-center">
      <div class="loader">Loading...</div>
    </div>
  `,
})
export class StartupLoadingComponent {}
